// src/hooks/usePageView.js

import { useEffect, useRef } from 'react';
import { collection, addDoc, serverTimestamp, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';

const VISITOR_ID_KEY = 'pv_visitor_id';
const SESSION_ID_KEY = 'pv_session_id';
const LAST_VIEW_PREFIX = 'pv_last_';

function getOrCreateID(storage, key) {
  let id = storage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    storage.setItem(key, id);
  }
  return id;
}

export default function usePageView(pageType, productID = null) {
  const hasFired = useRef(false);

  useEffect(() => {
    if (hasFired.current) return;

    const dedupKey = LAST_VIEW_PREFIX + (productID ? `product_${productID}` : pageType);
    const now = Date.now();
    const lastView = parseInt(sessionStorage.getItem(dedupKey) || '0', 10);

    if (now - lastView < 30_000) return;

    sessionStorage.setItem(dedupKey, String(now));
    hasFired.current = true;

    const visitorID = getOrCreateID(localStorage, VISITOR_ID_KEY);
    const sessionID = getOrCreateID(sessionStorage, SESSION_ID_KEY);

    const expireDate = new Date(now + 90 * 24 * 60 * 60 * 1000);

    addDoc(collection(db, 'pageViews'), {
      pageType,
      productID: productID || null,
      visitorID,
      sessionID,
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      screenWidth: window.innerWidth,
      timestamp: serverTimestamp(),
      expireAt: Timestamp.fromDate(expireDate),
    }).catch(() => {});
  }, [pageType, productID]);
}
